import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class UserInfoService {
	private userInfoSubject = new BehaviorSubject<any>(null);
	public userInfo$ = this.userInfoSubject.asObservable();

	constructor() {
		const initialUser = this.getUserInfoFromStorage();
		if (initialUser) {
			this.userInfoSubject.next(initialUser);
		}
	}

	private getUserInfoFromStorage() {
		let userData = JSON.parse(localStorage.getItem('user_info'));

		userData = {
			nameCode: `${userData?.name.split('').shift()}${userData?.lastName.split('').shift()}`,
			headerName: `${userData?.name.split(' ').shift()} ${userData?.lastName.split(' ').shift()}`,
			...userData
		};

		return userData;
	}

	public get userInfo() {
		return this.getUserInfoFromStorage();
	}

	public get disabled() {
		return false;
	}

	public refreshUserInfo(): void {
		const userData = this.getUserInfoFromStorage();
		this.userInfoSubject.next(userData);
	}

	public clearUserInfo(): void {
		this.userInfoSubject.next(null);
	}
}